import { registerModuleDataProvider } from '../../../providers/CustomDataProvider';
import { Resources } from '../../resource';
import { poolRewardClaimsDataProvider } from './dataProvider';

export function initSocialTradingPoolRewardClaimsDataProvider() {
  registerModuleDataProvider(Resources.socialTradingPoolRewardClaims, poolRewardClaimsDataProvider);
}

initSocialTradingPoolRewardClaimsDataProvider();
